import ApiService from "@/app/infrastructures/services/ApiService";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { PosRevenueMapper } from "@/data/persistences/mappers/PosRevenueMapper";
import { PosRevenueEndpoints } from "@/app/infrastructures/endpoints/hydra/PosRevenueEndpoints";

export class PosRevenueApiRepository {
  private service: ApiService;
  private mapper: PosRevenueMapper;
  private endpoints: PosRevenueEndpoints;

  constructor(
    service: ApiService,
    mapper: PosRevenueMapper,
    endpoints: PosRevenueEndpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getTopCommodity(
    params: { booked_by_pos?: string; limit?: number; page?: number } & Record<string, any>
  ): Promise<ResponsePayloadV2> {
    const url = this.endpoints.getTopCommodity(params);
    const resp = await this.service.invoke("get", url, {});
    return this.mapper.convertCommodityFromApi(resp);
  }
}